export default {"footerNavContainer":"mWuww","footerNavWrapper":"eKFOD","footerNavColumns":"xzU-s"};